import React from 'react';
import { ClockIcon } from './Icons';
import { formatTimeSavedHours } from './utils';

export function PageHeader({ timeSavedHours, children }) {
  return (
    <div className="ci-heading-row">
      <div className="ci-time-saved">
        <ClockIcon />
        Total time saved: <span>{formatTimeSavedHours(timeSavedHours)}</span>
      </div>
      <div className="ci-actions">{children}</div>
    </div>
  );
}
